<section class="page" [class.mobile-page]="isMobileBrowser()" data-testid="appointments-provider-location-page">
  <app-page-header
    title="Select a Location"
    subtitle="Choose the clinic where you'd like to be seen."
    [hideBack]="isModal"
    (back)="onCancel()"></app-page-header>

  <div class="page-content">
    <ng-container *ngrxLet="{ provider: patientCareTeamMember$, isLoading: isLoading$ } as vm">
      @if (vm.isLoading) {
        <app-progress-spinner data-testid="appointments-provider-location-spinner"></app-progress-spinner>
      } @else {
        <div class="list" data-testid="appointments-provider-location-list">
          <div class="search">
            <app-icon name="search" size="sm" color="on-surface"></app-icon>
            <input
              #searchInput
              type="text"
              class="search-input"
              placeholder="Search locations"
              [value]="searchText()"
              (input)="searchText.set($any($event.target).value || '')"
              aria-label="Search locations" />
            <button
              type="button"
              class="clear-btn"
              [class.is-hidden]="searchText().trim().length === 0"
              [disabled]="searchText().trim().length === 0"
              aria-label="Clear search"
              (click)="onClearSearch(searchInput)">
              <app-icon name="close" size="sm" color="on-surface"></app-icon>
            </button>
          </div>

          @if (vm.provider === null) {
            <div id="providerNotFound" class="empty" data-testid="appointments-provider-location-empty">
              <p>{{ getEmptyStateCopy(false) }}</p>
            </div>
          } @else if (filterTeams(vm.provider.teams).length === 0) {
            <div class="empty" data-testid="appointments-provider-location-empty">
              <p>{{ getEmptyStateCopy(true) }}</p>
            </div>
          } @else {
            <div class="option-grid" role="radiogroup" aria-label="Provider locations">
              @for (team of filterTeams(vm.provider.teams); track team.teamId; let idx = $index) {
                <div
                  class="option-card"
                  [class.is-selected]="selectedTeamId() === team.teamId"
                  [attr.data-testid]="'schedule-option-' + idx"
                  role="radio"
                  [attr.aria-checked]="selectedTeamId() === team.teamId"
                  tabindex="0"
                  (click)="onTeamActivate(team.teamId)"
                  (keydown)="onRowKeydown($event, team.teamId)">
                  <span class="left" aria-hidden="true">
                    <app-icon name="where_to_vote" size="sm" color="on-surface"></app-icon>
                  </span>

                  <span class="meta">
                    <span class="name">{{ getLocationLabel(team) }}</span>
                    @if (team.facilityAddress1) {
                      <span class="sub">{{ team.facilityAddress1 }}</span>
                    }
                    @if (team.facilityAddress2) {
                      <span class="sub">{{ team.facilityAddress2 }}</span>
                    }
                    @if (getAddressLine2(team)) {
                      <span class="sub">{{ getAddressLine2(team) }}</span>
                    }
                  </span>

                  <span class="right" aria-hidden="true">
                    @if (isMobileBrowser()) {
                      @if (selectedTeamId() === team.teamId) {
                        <span class="check">
                          <app-icon name="check" size="sm" color="on-primary"></app-icon>
                        </span>
                      } @else {
                        <span class="radio"></span>
                      }
                    } @else {
                      <app-icon name="chevron_right" size="sm" color="on-surface-variant"></app-icon>
                    }
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
    </ng-container>
  </div>

  @if (!isModal) {
    <footer class="page-footer">
      <button
        mat-stroked-button
        type="button"
        class="error-btn"
        data-testid="appointments-step-cancel"
        (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        mat-flat-button
        class="primary-btn"
        data-testid="appointments-step-continue"
        [disabled]="!selectedTeamId()"
        (click)="onContinue()">
        Continue
      </button>
    </footer>
  }
</section>
